import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";
import axios from "axios";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";

const DetalhesTurmaCheckpoint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [turma, setTurma] = useState(null);
  const userId = parseInt(localStorage.getItem("user_id"));

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await axios.get(`/api/turmas/${id}`);
        setTurma(response.data);
      } catch (error) {
        console.error("Erro ao buscar detalhes da turma:", error);
      }
    };

    fetchDados();
  }, [id]);

  if (!turma) {
    return <div className="form-wrapper">Carregando detalhes da turma...</div>;
  }

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Detalhes da Turma</h2>

      {/* Linha 1 */}
      <div className="form-row">
        <div className="form-group" style={{ width: "200px" }}>
          <label>Cód. da Turma</label>
          <div className="campo-detalhe">{turma.codigo}</div>
        </div>

        <div className="form-group">
          <label>Nome da Turma</label>
          <div className="campo-detalhe">{turma.nome}</div>
        </div>
      </div>

      {/* Linha 2 */}
      <div className="form-row">
        <div className="form-group" style={{ width: "200px" }}>
          <label>Cód. do Curso</label>
          <div className="campo-detalhe">{turma.curso_codigo}</div>
        </div>

        <div className="form-group">
          <label>Nome do Curso</label>
          <div className="campo-detalhe">{turma.curso_nome}</div>
        </div>
      </div>

      {/* Linha 3 */}
      <div className="form-row">
        <div className="form-group">
          <label>Coordenador</label>
          <div className="campo-detalhe">{turma.coordenador_nome}</div>
        </div>

        <div className="form-group">
          <label>E-mail do Coordenador</label>
          <div className="campo-detalhe">
            <a href={`mailto:${turma.coordenador_email}`} target="_blank" rel="noopener noreferrer">
              {turma.coordenador_email}
            </a>
          </div>
        </div>
      </div>

      {/* Linha 4 */}
      <div className="form-row">
        <div className="form-group" style={{ width: "220px" }}>
          <label>Modalidade do Curso</label>
          <div className="campo-detalhe">{turma.curso_modalidade}</div>
        </div>

        <div className="form-group" style={{ width: "220px" }}>
          <label>Data de Início</label>
          <div className="campo-detalhe">
            {turma.data_inicio ? new Date(turma.data_inicio).toLocaleDateString() : ""}
          </div>
        </div>

        <div className="form-group" style={{ width: "220px" }}>
          <label>Data de Término</label>
          <div className="campo-detalhe">
            {turma.data_termino ? new Date(turma.data_termino).toLocaleDateString() : ""}
          </div>
        </div>
      </div>

{/* 🔵 Disciplinas escaladas para este professor */}
<div className="form-group full-width">
  <label>Minhas Disciplinas nesta Turma</label>

  {turma.disciplinas_curso.filter(disc => {
    return turma.escalas_professores.some(
      escala => escala.disciplina_id === disc.id && escala.professor_id === userId
    );
  }).length > 0 ? (
    <table className="tabela" style={{ fontSize: "0.85rem", marginTop: "10px" }}>
      <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
        <tr>
          <th style={{ textAlign: "left" }}>Código</th>
          <th style={{ textAlign: "left" }}>Nome</th>
          <th style={{ textAlign: "center" }}>Ação</th>
        </tr>
      </thead>
      <tbody>
        {turma.disciplinas_curso.filter(disc => {
          return turma.escalas_professores.some(
            escala => escala.disciplina_id === disc.id && escala.professor_id === userId
          );
        }).map((disciplina, index) => (
          <tr key={index}>
            <td>{disciplina.codigo}</td>
            <td>{disciplina.nome}</td>
            <td style={{ textAlign: "center" }}>
              <button className="btn btn-primary" onClick={() => console.log("Abrir checkpoint para", disciplina)}>
                CheckPoint
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p style={{ marginTop: "10px" }}>Você não está escalado para nenhuma disciplina nesta turma.</p>
  )}
</div>

      {/* Botão Voltar */}
      <div className="form-actions">
        <button className="btn btn-secondary" onClick={() => navigate("/checkpoints")}>
          Voltar
        </button>
      </div>
    </div>
  );
};

export default DetalhesTurmaCheckpoint;
